export const EDITOR_TYPE__INLINE = 'EDITOR_TYPE__INLINE';
export const EDITOR_TYPE__WINDOWED = 'EDITOR_TYPE__WINDOWED';
export const EDITOR_TYPE__SIDE = 'EDITOR_TYPE__SIDE';
export const EDITOR_TYPE__INLINE_SIDE = 'EDITOR_TYPE__INLINE_SIDE';
export const EDITOR_TYPE__SMART = 'EDITOR_TYPE__SMART';
export const EDITOR_TYPE__PLAIN = 'EDITOR_TYPE__PLAIN';
export const EDITOR_MODE__VIEW = 'EDITOR_MODE__VIEW';
export const EDITOR_MODE__ADD = 'EDITOR_MODE__ADD';
export const EDITOR_MODE__EDIT = 'EDITOR_MODE__EDIT';